import React from 'react'
import Avatar from './Avatar'

const Chatdetails = ({name, url, livestate}) => {
    let fname = name.split(' ')[0]
  return (
    <div className='chat-user-details'>
        <span>{fname}</span>
        <Avatar imgurl={url} isOnline={livestate}/>
    </div>
  )
}

export default Chatdetails